/**
 * @module app.core
 */

import { autoinject } from 'aurelia-framework';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ComponentBase } from 'app/shared/lib/essette-site';
import { apiCall } from 'app/shared/lib/api/api';
import { UserService } from 'app/core/services/user-service';
import * as Core from 'app/core/models/essette-api';

@autoinject()
export class UserCustomerServiceCenters extends ComponentBase {

    ////****************** Fields and Properties ************************************////
    @bindable.objectNull({ changeHandler: 'loadCustomerServiceCenters' })
    protected user: Core.User | null = null;
    @bindable()
    public readonly: boolean = false;
    public locations: Core.Location[] = [];
    public selectedLocations: Core.Location[] = [];

    ////****************** Lifecycle events (in order of execution) *****************////
    constructor(
        private readonly userService: UserService,
        ...rest: any[]) {

        super(...rest);
    }

    protected bind() {
        this.loadCustomerServiceCenters();
    }

    ////****************** Functions ************************************************////

    isLocationChecked(location: Core.Location): boolean {
        return this.selectedLocations.some(l => this.compareLocations(l, location));
    }


    protected toggleLocation(location: any, checked: boolean): void {
        if(checked) {
            if(!this.isLocationChecked(location)) {
                this.selectedLocations = [...this.selectedLocations, location]
            }
        }
        else {
            this.selectedLocations = this.selectedLocations.filter(l => !this.compareLocations(l, location));
        }
    }

    protected compareLocations(a: Core.Location, b: Core.Location): boolean {
        return a.id === b.id;
    }

    ////****************** Service Calls ********************************************////
    @apiCall
    private async loadCustomerServiceCenters(): Promise<void> {
        if(!this.readonly) {
            const response = await this.userService.loadLocations({ all: true });
            this.locations = response.results;
            if(this.user?.locations) {
                this.selectedLocations = this.locations.filter(loc =>
                    this.user?.locations?.some(userLoc => this.compareLocations(userLoc, loc))
                )
            }
        }
        else {
            this.selectedLocations = [...(this.user?.locations || [])];
        }
    }
}
